import { FulfillmentCutoffScheduleParser } from "@redotech/redo-conversion-settings-common/fulfillment-cutoff";
import * as z from "zod";

export const getFulfillmentCutoffSchedule = {
  name: "getFulfillmentCutoffSchedule" as const,
  input: z.null(),
  output: z.object({ schedule: FulfillmentCutoffScheduleParser.optional() }),
};
